export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row gap-0">
          <div className="flex-1 flex flex-col justify-center py-10 md:py-16 px-6 md:px-12">
            <span className="flex items-center gap-2 text-xs font-label text-foreground-400 tracking-wide mb-8">
              <span className="w-1.5 h-1.5 rounded-full bg-foreground-900"></span>
              Verified Buyer
            </span>
            <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug mb-8">
              &ldquo;Using the hipobuy sheet
              <br />
              cut my research time by 80%.
              <br />
              It&rsquo;s the only database I trust.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <span className="font-label text-sm font-semibold text-foreground-900">Maya R.</span>
              <span className="flex items-center gap-1 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
              </span>
              <span className="text-xs text-foreground-400">Trustpilot</span>
            </div>
          </div>

          <div className="flex-1 min-h-[400px] md:min-h-[500px] relative overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20diverse%20young%20woman%20with%20natural%20curly%20hair%20looking%20directly%20at%20camera%20with%20a%20warm%20genuine%20smile%2C%20wearing%20a%20simple%20cream%20linen%20blouse%2C%20soft%20natural%20light%20from%20a%20large%20window%2C%20clean%20light%20gray%20studio%20background%2C%20modern%20editorial%20photography%2C%20relaxed%20and%20trustworthy%20expression%2C%20shallow%20depth%20of%20field%2C%20high%20end%20commercial%20portrait%20style%2C%20warm%20skin%20tones&width=600&height=800&seq=testimonial-portrait-fresh-v2&orientation=portrait"
              alt="Verified customer testimonial"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}